import { mapGetters } from 'vuex'

import ConfigurationDashboard from '@/agilis/util/ConfigurationDashboard'
import DashboardWrapper from '@/agilis/components/DashboardTabs/DashboardWrapper/DashboardWrapper.vue'
import TrackerDataTableView from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableView/TrackerDataTableView.js'

export default {
  name: 'OpportunityTableView',
  mixins: [
    TrackerDataTableView
  ],

  components: {
    DashboardWrapper
  },

  props: {
    configuration: Object
  },

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId',
      workspaceId: 'contextStore/workspaceId',
      trackerTypeId: 'contextStore/trackerTypeId',
      trackerId: 'contextStore/trackerId'
    })
  },

  methods: {
    getDashboardContext () {
      return ConfigurationDashboard.getTrackerDashboardContext(
        this.applicationId,
        this.workspaceId,
        this.trackerTypeId,
        this.trackerId
      )
    }
  }
}
